import React from 'react';
import { CheckCircleIcon, LeafIcon } from 'lucide-react';
export function MechanismSection() {
  const benefits = ['Support deeper sleep', 'Ease inflammation', 'Calm digestion', 'Strengthen immunity', 'Help the body restore balance'];
  return <section className="w-full bg-emerald-50 py-16 md:py-24" data-id="element-568">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-569">
        <div className="text-center mb-10" data-id="element-570">
          <div className="flex justify-center mb-4" data-id="element-571">
            <LeafIcon className="w-10 h-10 text-emerald-600" data-id="element-572" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-573">
            A Better Approach
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed" data-id="element-574">
            Herbal remedies work with the body by supporting natural healing
            processes.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-emerald-100 max-w-xl mx-auto" data-id="element-575">
          <ul className="space-y-5" data-id="element-576">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-577">
                <CheckCircleIcon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-578" />
                <span className="text-lg text-stone-800 font-medium" data-id="element-579">
                  {benefit}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}